import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ReclamosBreadcrumb } from "./UI/ModalIngresoReclamo/Breadcrumb/ReclamosBreadcrumb";
import { ReclamosIngreso } from "./UI/ModalIngresoReclamo/ReclamosIngreso";
import { useDispatch, useSelector } from "react-redux";
import { cleanReclamosTomados, getReclamosTomadosPorUsuario, setActiveBreadcrumbReclamos } from "../../actions/reclamos/reclamosActions";
import {
  AREAS_USUARIOS,
  MENU_RECLAMOS,
} from "../../utils/constants";
import { GestionReclamos } from "./UI/ModalGestionReclamos/GestionReclamos";
import { validarQueTengaAunqueSeaUnSoloPermiso } from "../../helpers/permisos";
import { RECLAMOS_PERMISOS } from "../../utils/permisos";
import { getAreasFisicasAction } from "../../actions/usuarios/areasFisicas";
import { GestionReclamosEfector } from "./UI/ModalIngresoReclamoEfector/ModalGestionReclamosEfector/GestionReclamosEfector";
import { ReclamosEnviados } from "./UI/ModalReclamosEnviados/ReclamosEnviados";
import { GestionReclamosExternos } from "./UI/ModalIngresoReclamosExternos/GestionReclamoExterno/GestionReclamosExternos";
import { AdministrarReclamos } from "./AdministrarReclamos";



const style = {
  root: {
    flexGrow: 1,
  },
};

export const ReclamosHome = (props) => {
  const dispatch = useDispatch();
  const [reclamos, setReclamos] = useState([]);
  const [reclamosEfector, setReclamosEfector] = useState([]);
  const { activeBreadcrumb, reclamosTomadosUsuario = {} } = useSelector((state) => state.reclamos);
  const { permisos: permisosUser, areas } = useSelector((state) => state.auth);


  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    dispatch(setActiveBreadcrumbReclamos(item));
  };

  useEffect(() => {
    dispatch(setActiveBreadcrumbReclamos(MENU_RECLAMOS.DESELECCIONAR));
    dispatch(getAreasFisicasAction());
  }, [dispatch]);

  console.log(areas)

  useEffect(() => {
    debugger
    if (props.location.state?.from !== "/reclamos/gestion") {
      dispatch(cleanReclamosTomados());
      if (areas.filter((area) => area.idArea === AREAS_USUARIOS.COMUNICACIONES
        || area.idArea === AREAS_USUARIOS.COMUNICACIONES)?.length > 0) {
        dispatch(getReclamosTomadosPorUsuario());
      }

      if (props.location.state?.sendGestion)
        dispatch(setActiveBreadcrumbReclamos(MENU_RECLAMOS.CONSULTA));

    } else {
      dispatch(setActiveBreadcrumbReclamos(MENU_RECLAMOS.INGRESO));
    }

    if (props.location.state?.activeBreadcrumb) {
      dispatch(setActiveBreadcrumbReclamos(props.location.state.activeBreadcrumb));
    }

  }, [props.location.state?.from, props.location.state?.fromHomeScreen, dispatch]);


  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <ReclamosBreadcrumb
            activeBreadcrumb={activeBreadcrumb}
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
            permisoIngresoSolicitudes={validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
              RECLAMOS_PERMISOS,
            ])}
          />
        </Grid>
        {activeBreadcrumb === MENU_RECLAMOS.INGRESO && (
          <ReclamosIngreso {...props} />
        )}
        {activeBreadcrumb === MENU_RECLAMOS.ENVIADOS && (
          <ReclamosEnviados {...props}/>
        )}
        {activeBreadcrumb === MENU_RECLAMOS.CONSULTA && (
          <GestionReclamos reclamos={reclamos} setreclamos={setReclamos} {...props}/>
        )}
        {activeBreadcrumb === MENU_RECLAMOS.GESTION_EFECTOR && (
          <GestionReclamosEfector reclamos={reclamosEfector} setreclamos={setReclamosEfector} {...props}/>
        )}
        {activeBreadcrumb === MENU_RECLAMOS.GESTION_EXTERNOS && (
          <GestionReclamosExternos reclamos={reclamosEfector} setreclamos={setReclamosEfector} {...props}/>
        )}
        {!activeBreadcrumb && reclamosTomadosUsuario.length > 0 &&
          <AdministrarReclamos
            type={'currentUser'}
          />
        }


      </Grid>
    </div>
  );
};

